import React, { useState, useEffect } from 'react';
import EmployeeForm from './EmployeeForm';
import { getDepartments, createEmployee } from '../api';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';

const EmployeeAdd = () => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getDepartments().then(res => {
      if (res.success) setDepartments(res.data);
    });
  }, []);

  const handleSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      if (key === 'documents' || key === 'skills' || key === 'leaves') return;
      if (key === 'profile_image') {
        if (value && value[0] && value[0].originFileObj) {
          formData.append('profile_image', value[0].originFileObj);
        }
        return;
      }
      // Only append if value is not null, undefined or empty string
      if (value !== undefined && value !== null && value !== '') {
        formData.append(key, value);
      }
    });
    formData.append('update_skills', '1');
    if (Array.isArray(values.skills)) {
      values.skills.forEach(skillId => {
        formData.append('skills[]', skillId);
      });
    }
    if (values.documents) {
      values.documents.forEach((doc, idx) => {
        formData.append(`documents[${idx}][document_type]`, doc.document_type || '');
        formData.append(`documents[${idx}][issue_date]`, doc.issue_date || '');
        formData.append(`documents[${idx}][expiry_date]`, doc.expiry_date || '');
        if (doc.document_file && doc.document_file[0]) {
          formData.append(`documents[${idx}][document_file]`, doc.document_file[0].originFileObj);
        }
      });
    }
    formData.append('update_leaves', '1');
    if (values.leaves) {
      values.leaves.forEach((leave, idx) => {
        formData.append(`leaves[${idx}][leave_type]`, leave.leave_type || '');
        formData.append(`leaves[${idx}][start_date]`, leave.start_date || '');
        formData.append(`leaves[${idx}][end_date]`, leave.end_date || '');
        formData.append(`leaves[${idx}][actual_return_date]`, leave.actual_return_date || '');
        formData.append(`leaves[${idx}][reason]`, leave.reason || '');
        if (leave.form_file && leave.form_file[0]) {
          formData.append(`leaves[${idx}][form_file]`, leave.form_file[0].originFileObj);
        }
      });
    }
    const res = await createEmployee(formData);
    setLoading(false);
    if (res.success) {
      message.success('Employee created');
      navigate('/employees');
    } else {
      message.error(res.message || 'Failed to create employee');
    }
  };

  return (
    <EmployeeForm
      mode="add"
      departments={departments}
      onSubmit={handleSubmit}
      loading={loading}
      onCancel={() => navigate('/employees')}
    />
  );
};

export default EmployeeAdd; 